<template>
  <div class="container materialGRIC1">
    <div class="searchBox_top">
      <el-button v-if="btnAdd" size="mini" type="primary" @click="showDialog=true">{{$t('common.newBuilt')}}</el-button>
      <el-button v-if="btnDelete" size="mini" type="danger" @click="deleteRow">{{$t('common.del')}}</el-button>
    </div>
    <span>Category1</span>
    <el-table ref="tableData" :data="tableData" row-key="tmCategoryId" border highlight-current-row class="headList">
      <el-table-column fixed sortable type="selection" width="55" align="center" :reserve-selection="true"></el-table-column>
      <el-table-column prop='name' :label="$t('material.tyep')"></el-table-column>
      <el-table-column prop='statusI18n' :label="$t('material.conductStatus')"></el-table-column>
      <el-table-column :label="$t('base.linePrice.operation')">
        <template slot-scope="scope">
          <div v-if="scope.row.status=='effective'" class="a-link" @click="disable(scope.row.tmCategoryId,'invalid')">Disable
          </div>
          <div v-if="scope.row.status=='invalid'" class="a-link" @click="disable(scope.row.tmCategoryId,'effective')">Enable
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination">
      <el-pagination @size-change="pageSizeChange" @current-change="pageNumberChange" :current-page="queryCondition.pageNum" :page-sizes="pageSizeList" :page-size="queryCondition.pageSize" :layout="pageLayout" :total="totalCount"></el-pagination>
    </div>
    <el-dialog :title="$t('material.add')" :visible.sync="showDialog" width="500px">
      <el-form :model="info" ref="info" class="form_border" :rules="rules" label-width="100px">
        <el-row type="flex" justify="space-around">
          <el-form-item label="Category1" placeholder="" prop="name">
            <el-input v-model="info.name" class="handle-input" />
          </el-form-item>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer" align="center">
        <el-button type="primary" @click="saveCategory(info.name)">{{$t('common.submit')}}</el-button>
        <el-button type="primary" @click="showDialog = false">{{$t('common.close')}}</el-button>
      </div>
    </el-dialog>
  </div>

</template>

<script>
import IcSelect from "@/components/common/icSelect";
import { apiService } from "@/api/material/material-master-data";
import GRIApi from "@/api/material/GRI";
import commonFunction from "@/utils/dataTableUtils";
import { Message } from "element-ui";

export default {
  components: { IcSelect },
  extends: commonFunction,
  data() {
    return {
      queryCondition: {
        pageNum: 1,
        pageSize: 15,
        categoryLevel: 1
      },
      tableData: [],
      totalCount: 0,
      showDialog: false,
      btnAdd: false,
      btnDelete: false,
      info: { name: null, categoryLevel: 1 },
      rules: {
        name: [
          { required: true, message: this.$t("common.canNotBeEmpty"), trigger: "blur" }
        ]
      },
    }
  },
  created() {
    this.queryData(1)
    this.getUserType()
  },
  methods: {
    queryData(val) {
      if (undefined != val) {
        this.queryCondition.pageNum = 1;
      }
      apiService.findListCategory(this.queryCondition).then((res) => {
        this.tableData = res.resultData;
        this.totalCount = res.totalCount;
      });
    },
    disable(tmCategoryId, status) {
      let that = this
      let data = {
        tmCategoryId: tmCategoryId,
        status: status
      }
      GRIApi.disableCategory(data).then((res) => {
        that.$message({
          message: this.$t("common.success"),
          type: "success"
        });
        this.queryData(1)
      });
    },
    saveCategory(name) {
      this.$refs.info.validate(valid => {
        if (valid) {
          GRIApi.saveCategory(this.info).then((res) => {
            this.$message({
              message: this.$t("common.success"),
              type: "success"
            });
            this.showDialog = false
            this.info.name = null
            this.queryData(1)
          });
        } else {
          Message({ message: that.$t('common.PleaseRequired'), type: "error" });
          return false;
        }
      });
    },
    async deleteRow() {
      let rows = this.$refs.tableData.selection;
      if (rows.length == 0) {
        this.$message({
          message: this.$t("common.pleaseSelectData"),
          type: "warning"
        });
      } else {
        if (await this.callConfirm()) {
          let ids = rows.map(data => data.tmCategoryId)
          GRIApi.deleteBatchIds(ids).then((res) => {
            if (res.code === '200') {
              Message({ message: this.$t('common.delSuccess'), type: "success" });
            } else {
              Message({ message: this.$t('common.delError'), type: "error" });
            }
            this.queryData();
          });
        }
      }
    },
    getUserType() {
      let permission = JSON.parse(localStorage.getItem("ms_Permission"));
      for (let i = 0, len = permission.length; i < len; i++) {
        if (permission[i] == 'category1_add') {//新建
          this.btnAdd = true;
        }
        if (permission[i] == 'category1_delete') {//删除
          this.btnDelete = true;
        }
      }
    },

  }

}
</script>
<style lang="scss" scoped>
.searchBox_top {
  margin-bottom: 20px;
}

.el-table {
  margin-top: 10px;
}
</style>
<style lang="scss">
.materialGRIC1 {
  .headList {
    // width: 400px;
  }
}
</style>
